// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --canvas-ink: #11120f;
  --canvas-paper: #e8e5dc;
  --canvas-acid: #d8ff45;
  --canvas-orange: #ff6b35;
  --canvas-muted: #72786b;
}

* { box-sizing: border-box; }

html, body, #root { min-height: 100%; }

html { background: var(--canvas-ink); }

body {
  margin: 0;
  color: var(--canvas-ink);
  background: var(--canvas-paper);
  font-family: 'Avenir Next', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

button, input, textarea, select { font: inherit; }
button { cursor: pointer; }

::selection {
  color: #11120f;
  background: #d8ff45;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,oBAAoB,gBAAgB,EAAE;;AAEtC,OAAO,6BAA6B,EAAE;;AAEtC;EACE,SAAS;EACT,wBAAwB;EACxB,+BAA+B;EAC/B,wEAAwE;EACxE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,kCAAkC,aAAa,EAAE;AACjD,SAAS,eAAe,EAAE;;AAE1B;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[":root {\n  --canvas-ink: #11120f;\n  --canvas-paper: #e8e5dc;\n  --canvas-acid: #d8ff45;\n  --canvas-orange: #ff6b35;\n  --canvas-muted: #72786b;\n}\n\n* { box-sizing: border-box; }\n\nhtml, body, #root { min-height: 100%; }\n\nhtml { background: var(--canvas-ink); }\n\nbody {\n  margin: 0;\n  color: var(--canvas-ink);\n  background: var(--canvas-paper);\n  font-family: 'Avenir Next', 'PingFang SC', 'Microsoft YaHei', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\nbutton, input, textarea, select { font: inherit; }\nbutton { cursor: pointer; }\n\n::selection {\n  color: #11120f;\n  background: #d8ff45;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
